import { render, staticRenderFns } from "./BasketListItem.vue?vue&type=template&id=24042a80"
import script from "./BasketListItem.vue?vue&type=script&lang=js"
export * from "./BasketListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports